import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty, kebabCase } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from '../components/layouts/BoxedContainer';
import ScheduleCard from '../components/schedule-card/ScheduleCard';
import Button from '../components/layouts/Button';

export default function BookingTypesBlock({ data }) {
  const { title, textContent, dswSportPriceCardLists, link, link2, paddingBottom, sportsLogo } =
    data;
  return (
    <section
      className={`bg-white lg:pt-[160px] pt-[80px] lg:-mt-[80px] -mt-[20px] ${
        paddingBottom ? 'lg:pb-[140px] pb-[80px]' : ''
      }`}>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}>
        <BoxedContainer className="regular">
          <div className="max-w-[870px]">
            <div className="lg:mb-[48px] mb-[30px]">
              <div className="flex flex-col md:flex-row gap-4 md:gap-5 justify-between">
                <h2
                  className="lg:w-[70%] lg:text-2xl text-[35px] lg:leading-[50px] leading-[48px]
              font-roboto-condensed-bold flex flex-col uppercase"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                {isEmpty(sportsLogo) || (
                  <LazyLoadImage
                    src={sportsLogo.url}
                    alt="Sports Logo"
                    className="w-[132px] !h-[92px]"
                  />
                )}
              </div>
              {isEmpty(textContent) || (
                <div
                  className="lg:text-[16px] text-[15px] lg:leading-[30px] leading-6
                font-roboto-regular lg:mt-[26px] mt-[15px]"
                  dangerouslySetInnerHTML={{ __html: textContent }}
                />
              )}
            </div>

            <div className="flex flex-col gap-y-4">
              {dswSportPriceCardLists &&
                dswSportPriceCardLists.map((block, ind) => (
                  <div key={ind} className="flex flex-col gap-y-3 md:gap-y-6">
                    <h3
                      className="lg:text-[16px] text-[14px] lg:leading-[24px] leading-7
                    font-roboto-condensed-bold uppercase">
                      {block.content.title}
                    </h3>
                    <div className="flex flex-wrap md:gap-x-[30px] gap-x-[10px]">
                      {block.content.dswSportPriceCards &&
                        block.content.dswSportPriceCards.map((schedule, inde) => (
                          <ScheduleCard key={inde} data={schedule.content} />
                        ))}
                    </div>
                  </div>
                ))}
            </div>

            <div className="flex flex-wrap md:gap-x-[20px] gap-x-[10px] gap-y-[15px]">
              {link && (
                <div>
                  <Button
                    url={link.url}
                    label={link.name}
                    target={link.target}
                    ariaLabel={link.name}
                    tagName="sports-details-book-button-one"
                    variant="primaryRed"
                    text="md:min-w-[170px] w-fit h-[45px] px-[25px] whitespace-pre
                  md:mt-[60px] mt-[20px]"
                  />
                </div>
              )}
              {link2 && (
                <div>
                  <Button
                    url={link2.url}
                    target={link2.target}
                    label={link2.name}
                    ariaLabel={link2.name}
                    tagName="sports-details-book-button-two"
                    variant="secondaryRed"
                    text="md:min-w-[170px] w-fit h-[45px] px-[25px] whitespace-pre
                  md:mt-[60px] mt-[20px]"
                  />
                </div>
              )}
            </div>
          </div>
        </BoxedContainer>
      </motion.div>
    </section>
  );
}
